export default "/public/dist/img/IMG2.png";